import * as React from "react";

/**
 * useMounted — true after the component has mounted on the client.
 * SSR-safe escape hatch for code that only makes sense in the browser.
 */
export function useMounted(): boolean {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);
  return mounted;
}
